import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.css']
})
export class DeleteDialogComponent {
  constructor(
    public dialogRef:MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any){
     
  }
  onCancelClick():void{
    this.dialogRef.close(false);
  }

  onDeleteClick():void{
    this.dialogRef.close(true);
  }

  onCloseClick():void{
    this.dialogRef.close();
  }
}
